import script from "./AppBuildFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBuildFooter.vue?vue&type=script&setup=true&lang=js"

import "./AppBuildFooter.vue?vue&type=style&index=0&id=532fd5dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-532fd5dc"]])

export default __exports__